export const ZAKAT_COPY = {
  en: {
    title: "Zakat Eligibility",
    subtitle: "Please read and confirm your eligibility.",
    infoBox:
      'By selecting "Yes" below, you confirm that you meet all the above criteria and are eligible for Zakat assistance according to Shariah principles.',
    bullets: [
      { text: "I am Muslim and an adult", subItems: [] },
      {
        text: "I do not own",
        subItems: [
          "gold exceeding 7.5 tola, and/or",
          "silver exceeding 52.5 tola, and/or",
          "cash, foreign currency, bonds, certificates, or tradable assets whose total value exceeds the value of 52.5 tola of silver.",
        ],
      },
      {
        text: "I hereby declare that I do not belong to a Syed, Hashmi, or Abbasi family",
        subItems: [
          'If the word "Syed/Hashmi/Abbasi" is appearing in my name or my father\'s name it is used only as a name and does not indicate Syed, Hashmi, or Abbasi lineage. Accordingly, this does not affect my Zakat eligibility according to Shariah principles',
        ],
      },
      {
        text: "Based on the above, I confirm that I am eligible to receive Zakat according to Shariah principles.",
        subItems: [],
      },
      {
        text: "I authorize The Citizens Foundation (TCF) and its representatives to receive Zakat on my behalf and utilize it for educational purposes, including:",
        subItems: [
          "My educational expenses, and/or",
          "The educational expenses of other deserving students, and/or",
          "Transfer of Zakat into the ownership of The Citizens Foundation, in accordance with Shariah.",
        ],
      },
    ],
    optionYes: "Yes, I meet all the criteria",
    optionNo: "No, I do not meet the criteria",
    continueBtn: "Continue",
    noResponse: "No response submitted yet.",
  },
  ur: {
    title: "زکوٰۃ کی اہلیت",
    subtitle: "براہِ کرم پڑھیں اور اپنی اہلیت کی تصدیق کریں۔",
    infoBox:
      'نیچے "جی ہاں" کا انتخاب کر کے، آپ تصدیق کرتے ہیں کہ آپ مندرجہ بالا تمام شرائط پر پورا اترتے ہیں اور شرعی اصولوں کے مطابق زکوٰۃ کی امداد کے اہل ہیں۔',
    bullets: [
      { text: "میں مسلمان اور بالغ ہوں", subItems: [] },
      {
        text: "میری ملکیت میں مندرجہ ذیل چیزیں نہیں ہیں:",
        subItems: [
          "سونا جو 7.5 تولے سے زیادہ ہو، اور/یا",
          "چاندی جو 52.5 تولے سے زیادہ ہو، اور/یا",
          "نقد رقم، غیر ملکی کرنسی، بانڈز، سرٹیفکیٹس، یا تجارتی اثاثے جن کی کل مالیت 52.5 تولے چاندی کی قیمت سے زیادہ ہو۔",
        ],
      },
      {
        text: "میں اس بات کا اقرار کرتا/کرتی ہوں کہ میرا تعلق سید، ہاشمی، یا عباسی خاندان سے نہیں ہے",
        subItems: [
          'اگر میرے یا میرے والد کے نام میں لفظ "سید/ہاشمی/عباسی" آ رہا ہے تو یہ صرف نام کے طور پر استعمال ہوا ہے اور یہ سید، ہاشمی، یا عباسی نسب کو ظاہر نہیں کرتا۔ اس کے مطابق، یہ شرعی اصولوں کے تحت میری زکوٰۃ کی اہلیت کو متاثر نہیں کرتا',
        ],
      },
      {
        text: "مندرجہ بالا کی بنیاد پر، میں اس بات کی تصدیق کرتا/کرتی ہوں کہ میں شرعی اصولوں کے مطابق زکوٰۃ حاصل کرنے کا اہل/اہلیہ ہوں۔",
        subItems: [],
      },
      {
        text: "میں دی سٹیزنز فاؤنڈیشن (TCF) اور اس کے نمائندوں کو اپنی طرف سے زکوٰۃ وصول کرنے اور اسے تعلیمی مقاصد کے لیے استعمال کرنے کا اختیار دیتا/دیتی ہوں، بشمول:",
        subItems: [
          "میرے تعلیمی اخراجات، اور/یا",
          "دوسرے مستحق طلباء کے تعلیمی اخراجات، اور/یا",
          "شریعت کے مطابق زکوٰۃ کی ملکیت دی سٹیزنز فاؤنڈیشن کو منتقل کرنا۔",
        ],
      },
    ],
    optionYes: "جی ہاں، میں تمام شرائط پر پورا اترتا/اترتی ہوں",
    optionNo: "جی نہیں، میں شرائط پر پورا نہیں اترتا/اترتی ہوں",
    continueBtn: "جاری رکھیں",
    noResponse: "ابھی تک کوئی جواب جمع نہیں ہوا۔",
  },
};

export function buildZakatPrintSection(details = {}) {
  const copy = ZAKAT_COPY.en;
  const normalized =
    details.zakatEligible === null ||
    details.zakatEligible === undefined ||
    details.zakatEligible === ""
      ? ""
      : String(details.zakatEligible).trim();
  const lower = normalized.toLowerCase();

  let eligibilityLabel = "N/A";
  let responseText = copy.noResponse;
  let responseClass = "na";

  if (lower === "yes") {
    eligibilityLabel = "Yes";
    responseText = copy.optionYes;
    responseClass = "yes";
  } else if (lower === "no") {
    eligibilityLabel = "No";
    responseText = copy.optionNo;
    responseClass = "no";
  }

  return {
    title: copy.title,
    subtitle: copy.subtitle,
    infoBox: copy.infoBox,
    bullets: copy.bullets,
    eligibilityLabel,
    responseText,
    responseClass,
  };
}
